import React, {FunctionComponent} from "react";
import {HTMLInputElementProps, PropsWithOverwrite} from "../../../utils/input";
import clsx from "clsx";

export type InputToggleSwitchProps = PropsWithOverwrite<HTMLInputElementProps, {
    checked: boolean;
    onChange: (value: boolean) => void;
}>;

const InputToggleSwitch: FunctionComponent<InputToggleSwitchProps> = ({checked, onChange, className, ...inputAttr}) => {
    return (
        <input
            type="checkbox"
            id={inputAttr.name}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            className={clsx(className, "input-toggle-switch")}
            {...inputAttr}
        />
    );
};

export default InputToggleSwitch;
